export const CREATE_BOM_PRODUCTION_PROCESS = "CREATE_BOM_PRODUCTION_PROCESS";
export const CREATE_BOM_PRODUCTION_PROCESS_SUCCESS = "CREATE_BOM_PRODUCTION_PROCESS_SUCCESS";
export const CREATE_BOM_PRODUCTION_PROCESS_FAILED = "CREATE_BOM_PRODUCTION_PROCESS_FAILED";

export const UPDATE_BOM_PRODUCTION_PROCESS = "UPDATE_BOM_PRODUCTION_PROCESS";
export const UPDATE_BOM_PRODUCTION_PROCESS_SUCCESS = "UPDATE_BOM_PRODUCTION_PROCESS_SUCCESS";
export const UPDATE_BOM_PRODUCTION_PROCESS_FAILED = "UPDATE_BOM_PRODUCTION_PROCESS_FAILED";

export const GET_BOM_PRODUCTION_PROCESS = "GET_BOM_PRODUCTION_PROCESS";
export const GET_BOM_PRODUCTION_PROCESS_SUCCESS = "GET_BOM_PRODUCTION_PROCESS_SUCCESS";
export const GET_BOM_PRODUCTION_PROCESS_FAILED = "GET_BOM_PRODUCTION_PROCESS_FAILED";

export const DELETE_BOM_PRODUCTION_PROCESS = "DELETE_BOM_PRODUCTION_PROCESS";
export const DELETE_BOM_PRODUCTION_PROCESS_SUCCESS = "DELETE_BOM_PRODUCTION_PROCESS_SUCCESS";
export const DELETE_BOM_PRODUCTION_PROCESS_FAILED = "DELETE_BOM_PRODUCTION_PROCESS_FAILED";
